import { useContext } from 'react';
import Button from 'components/button/Button';
import { PlaylistsContext } from 'contexts/playlists';
import { IPlaylist } from 'contexts/playlists/types';

type IAssignPlaylistButton = {
  playlist: IPlaylist;
  setFetching: (fetching: boolean) => void;
  onRefreshAfterAssignment: () => Promise<void>;
};

const AssignPlaylistButton = (props: IAssignPlaylistButton): JSX.Element => {
  const { playlist, setFetching, onRefreshAfterAssignment } = props;

  const { actions } = useContext(PlaylistsContext);
  const handleAssignUser = async () => {
    setFetching(true);
    try {
      await actions.onAssignUser(playlist);
      await onRefreshAfterAssignment();
    } finally {
      setFetching(false);
    }
  };

  return (
    <Button $primary onClick={handleAssignUser}>
      Assign Playlist
    </Button>
  );
};

export default AssignPlaylistButton;
